export default __webpack_public_path__ + "static/media/arros.4ff3e640.jpg";